const checkoutCartRoute = ['checkout/cart','checkout/checkout','/checkout/cart','/checkout/checkout'];

window.getURLVar = function(key) {
  var value = [];

  var query = String(document.location).split('?');

  if (query[1]) {
    var part = query[1].split('&');

    for (var i = 0; i < part.length; i++) {
      var data = part[i].split('=');

      if (data[0] && data[1]) {
        value[data[0]] = data[1];
      }
    }

    if (value[key]) {
      return value[key];
    } else {
      return '';
    }
  } else {
    return window.location.pathname;
  }
}

window.show_load = function() {
  layer.load(2, {shade: [0.3,'#fff'] });
}

window.hide_load = function() {
  layer.closeAll('loading');
}

window.cart_ajax_load_html = function() {
  $('#cart, .side-cart').load('index.php?route=common/cart/info');
}

window.copyText = function(event) {
  var range = document.createRange();
  range.selectNode(event);
  var selection = window.getSelection();
  if ( selection.rangeCount > 0 ) selection.removeAllRanges();
  selection.addRange(range);
  document.execCommand('copy');
  layer.msg('OK');
}

// ajax 默认全局设置
$.ajaxSetup({
  cache: false,
  // beforeSend: function() { show_load(); },
  // complete: function() { hide_load(); },
  error: function(xhr, ajaxOptions, thrownError) {
    // console.error(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
  }
});

// 所有表单提交加入 load 动画，防止用户联系点击 导致两次提交
jQuery(document).ready(function($) {
  $("form").submit(function () {
    layer.load(2,{shade: [0.2,'#fff']});
  });
});

// Cart add remove functions
window.cart = {
  'add': function(product_id, quantity, product_model, product_name, gioIde) {
    $.ajax({
      url: 'index.php?route=checkout/cart/add',
      type: 'post',
      data: 'product_id=' + product_id + '&quantity=' + (typeof(quantity) != 'undefined' ? quantity : 1),
      dataType: 'json',
      beforeSend: function() { show_load(); },
      complete: function() { hide_load(); },
      success: function(json) {
        $('.alert-dismissible, .text-danger').remove();

        if (json['redirect']) {
          location = json['redirect'];
        }

        if (json['success']) {
          layer.msg(json['success']);
          if (gioIde) {
            console.log(gioIde, {
              'eshop_Productnumber_cms': product_model,
              'eshop_productname_cms': product_name,
              'eshop_addtoShoppingCart_No': common.getGIOValue('data-gio-product-num') || '1'
            });
            gio('track', gioIde, {
              'eshop_Productnumber_cms': product_model,
              'eshop_productname_cms': product_name,
              'eshop_addtoShoppingCart_No': common.getGIOValue('data-gio-product-num') || '1'
            });
            userAction.addCart(product_name);
          }
          $('#cart, .side-cart').load('index.php?route=common/cart/info');
          $('#bottom-tab-menu .cart-total').show();
        }
      }
    });
  },
  'remove': function(key) {
    $.ajax({
      url: 'index.php?route=checkout/cart/remove',
      type: 'post',
      data: 'key=' + key,
      dataType: 'json',
      beforeSend: function() { show_load(); },
      complete: function() { hide_load(); },
      success: function(json) {
        if ($.inArray(getURLVar('route'), checkoutCartRoute) != -1) {
          location = window.location.href;
        } else {
          $('#cart, .side-cart').load('index.php?route=common/cart/info');
        }
      }
    });
  }
};

window.voucher = {
  'remove': function(key) {
    $.ajax({
      url: 'index.php?route=checkout/cart/remove',
      type: 'post',
      data: 'key=' + key,
      dataType: 'json',
      success: function(json) {
        if ($.inArray(getURLVar('route'), checkoutCartRoute) != -1) {
          location = window.location.href;
        } else {
          $('#cart, .side-cart').load('index.php?route=common/cart/info');
        }
      }
    });
  }
}

window.wishlist = {
  'add': function(product_id, product_model, product_name, gioType) {
    $.ajax({
      url: 'index.php?route=account/wishlist/add',
      type: 'post',
      data: 'product_id=' + product_id,
      dataType: 'json',
      beforeSend: function() { show_load(); },
      complete: function() { hide_load(); },
      success: function(json) {
        $('.alert-dismissible').remove();

        if (json['redirect']) {
          location = json['redirect'];
        }

        if (json['success']) {
          layer.msg(json['success']);
          if (gioType) {
            console.log(gioType, {
              'eshop_Productnumber_cms': product_model,
              'eshop_productname_cms': product_name
            });
            gio('track', gioType, {
              'eshop_Productnumber_cms': product_model,
              'eshop_productname_cms': product_name
            });
            userAction.addFavorites(product_name);
          }
          $('#button-add-to-wishlist').addClass('active');
        }

        $('#wishlist-total span').html(json['total']);
        $('#wishlist-total').attr('title', json['total']);
      }
    });
  },
  'remove': function(product_id, product_model, product_name, ) {
    $.ajax({
      url: 'index.php?route=account/wishlist/remove',
      type: 'post',
      data: 'product_id=' + product_id,
      dataType: 'json',
      beforeSend: function() { show_load(); },
      complete: function() { hide_load(); },
      success: function(json) {
        if (json['success']) {
          layer.msg(json['success']);
          $('#button-add-to-wishlist').removeClass('active');
        }
        if (json['info']) {
          layer.msg(json['info']);
        }
        userAction.removeFavorites(product_name);
      }
    });
  }
}

window.compare = {
  'add': function(product_id, product_model, product_name, gioType, dom) {
    if (parseInt($('#compare-count').html()) >= 4) {
      solution_msg.toast('对比栏已满，只能装四个哦！');
      return;
    }
    $.ajax({
      url: 'index.php?route=product/compare/add',
      type: 'post',
      data: 'product_id=' + product_id,
      dataType: 'json',
      success: function(json) {
        $('.alert-dismissible').remove();

        if (dom) {
          $(dom).addClass('cur-compared').attr('disabled', true);
        }

        if (json['success']) {
          layer.msg(json['success']);
          if (gioType) {
            console.log(gioType, {
              'eshop_Productnumber_cms': product_model,
              'eshop_productname_cms': product_name
            });
            gio('track', gioType, {
              'eshop_Productnumber_cms': product_model,
              'eshop_productname_cms': product_name
            });
          }
          $('#compare-total').html(json['total']);
        }
        userAction.addCompare(product_name);
        compare.update();
        compare.getList();
      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
      }
    });
  },
  'update': function () {
    $.ajax({
      url: 'index.php?route=product/compare/get',
      type: 'post',
      dataType: 'json',
      success: function(json) {
        if (json['success']) {
          $('#compare-count').html(json['total']);
        }
      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
      }
    });
  },
  'remove': function(product_ids) {
    $.ajax({
      url: 'index.php?route=product/compare/delete',
      type: 'post',
      data: {'product_ids': product_ids},
      dataType: 'json',
      success: function() {
        product_ids.forEach(function (id) {
          var compareBtn = $('.j-compare-btn[data-product-id='+id+']');
          if (compareBtn && compareBtn.length > 0) {
            compareBtn.removeClass('cur-compared').attr('disabled', false);
          }
        });
        compare.getList();
      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
      }
    });
  },
  'getList': function() {
    $.ajax({
      url: 'index.php?route=product/compare/getlist',
      type: 'post',
      dataType: 'json',
      success: function(json) {
        if (json && json.length > 0) {
          var oCompareBox = $('#absCompareProduct');
          if (oCompareBox && oCompareBox.length > 0) {
            oCompareBox.html('');
            $(json).each(function (index, item) {
              var itemTemp = '<div class="compare-item" data-product-id="' + item.id +'"></div>';
              oCompareBox.append(itemTemp);

              var oItem = oCompareBox.find('.compare-item[data-product-id='+item.id+']');
              oItem.html($('#productTemp').html());

              oItem.find('.com-tips').text(item.name).attr('title', item.name);
              oItem.find('.compare-cover > img').attr('src', item.image);
              oItem.find('.compare-remove-btn').show();
            });

            if (json.length >= 2) {
              $('.begin-compare-btn').removeClass('disable-compare');
            } else {
              $('.begin-compare-btn').addClass('disable-compare');
            }

          }
          solution_msg.compareDialog();
        } else {
          $('.close-compare-box').click();
        }
        $('#compare-count').html(json.length);
      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
      }
    });
  }
}

console.log('%c                  ___                               \n' +
    '    _____        /\\__\\                              \n' +
    '   /::\\  \\      /:/ _/_                             \n' +
    '  /:/\\:\\  \\    /:/ /\\__\\                            \n' +
    ' /:/  \\:\\__\\  /:/ /:/ _/_  ___     ___  ___     ___ \n' +
    '/:/__/ \\:|__|/:/_/:/ /\\__\\/\\  \\   /\\__\\/\\  \\   /\\__\\\n' +
    '\\:\\  \\ /:/  /\\:\\/:/ /:/  /\\:\\  \\ /:/  /\\:\\  \\ /:/  /\n' +
    ' \\:\\  /:/  /  \\::/_/:/  /  \\:\\  /:/  /  \\:\\  /:/  / \n' +
    '  \\:\\/:/  /    \\:\\/:/  /    \\:\\/:/  /    \\:\\/:/  /  \n' +
    '   \\::/  /      \\::/  /      \\::/  /      \\::/  /   \n' +
    '    \\/__/        \\/__/        \\/__/        \\/__/    \n' +
    '     ___          ___          ___          ___   \n' +
    '    /\\__\\        /\\  \\        /\\  \\        /\\  \\  \n' +
    '   /:/ _/_       \\:\\  \\      /::\\  \\      /::\\  \\ \n' +
    '  /:/ /\\  \\       \\:\\  \\    /:/\\:\\  \\    /:/\\:\\__\\\n' +
    ' /:/ /::\\  \\  ___ /::\\  \\  /:/  \\:\\  \\  /:/ /:/  /\n' +
    '/:/_/:/\\:\\__\\/\\  /:/\\:\\__\\/:/__/ \\:\\__\\/:/_/:/  / \n' +
    '\\:\\/:/ /:/  /\\:\\/:/  \\/__/\\:\\  \\ /:/  /\\:\\/:/  /  \n' +
    ' \\::/ /:/  /  \\::/__/      \\:\\  /:/  /  \\::/__/   \n' +
    '  \\/_/:/  /    \\:\\  \\       \\:\\/:/  /    \\:\\  \\   \n' +
    '    /:/  /      \\:\\__\\       \\::/  /      \\:\\__\\  \n' +
    '    \\/__/        \\/__/        \\/__/        \\/__/  ', 'color:#02afe9;');

setTimeout(function () {
  console.log('%c_________________________________________________________','color:#02afe9;')
  console.log('标题(title):',window.cateData.userRecordOption.title)
  console.log('栏目模块(module):',window.cateData.userRecordOption.module)
  console.log('一级栏目(category1):',window.cateData.userRecordOption.category1)
  console.log('二级栏目(category2):',window.cateData.userRecordOption.category2)
  console.log('三级栏目(category3):',window.cateData.userRecordOption.category3)
  console.log('%c_________________________________________________________','color:#02afe9;')
},1000)

